import { Component, OnInit, ViewEncapsulation, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { interval, Subscription, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import _moment from 'proxies/dayjs';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
    selector: 'kx-queue-view',
    templateUrl: './queue-view.component.html',
    styleUrls: ['./queue-view.component.scss'],
    standalone: false
})
export class QueueViewComponent implements OnInit {
  moment = _moment;
  sliderImages: any; resourceDef: any;
  stop: boolean = true;
  subscription: Subscription;
  _hasSubscription: Subscription;
  haSubscription: Subscription
  hasSliderSubscription: Subscription;
  intervalId: number;
  hasDoctor: any;
  config: any;
  doctorPerScreen: any[];
  practitionerlist: any;
  myInterval: any
  activeSlideIndex = 0;
  showIndicator: boolean = false
  patientList: boolean = false;
  doctorDetail: any;
  doctorId: any;
  hasDoctorLength: any;
  navbarClicked: boolean = false
  // wingId: any;

  constructor(
    private service: BaseService,
    private aRoute: ActivatedRoute,
    private storage: StorageService,
    public elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  @HostListener('document:click', ['$event'])
  handleClick(event: MouseEvent) {
    const navbarTogglers = document.getElementsByClassName('navbar-toggler');
    for (let i = 0; i < navbarTogglers.length; i++) {
      this.renderer.listen(navbarTogglers[i], 'click', () => {
        if (!this.navbarClicked) {
          this.navbarClicked = true;
          console.log('Navbar click');
          let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
          hideSidebar.style.display = "";
          this.navbarButtonClick();
        }
      });
    }
  }

  ngOnInit() {
    this.hasBackgroundcolor();
    this.storage.setCurrentResource("consultation_queue_management");
    this.service.setTitle("label.title.queue_management");
    this._hasSubscription = this.aRoute.params.subscribe((urlObj: any) => {
      this.service.getResourceDef(urlObj['resource'], (resourceDef) => {
        if (resourceDef) {
          this.resourceDef = resourceDef
          this.doctor(urlObj['id'], resourceDef);
          this.getRefershTime(urlObj['id'], resourceDef);
        }
      })
    })
  }
  getDoctorList$(wingId: any, resourcedef: any): Observable<any> {
    var queryId = resourcedef.datasource.query_id;
    var args = resourcedef.datasource.args.replace("!!!getterKey!!!", wingId);
    var resource = resourcedef.datasource.resource;
    var application = resourcedef.datasource.application;
    return this.service.get(queryId, args, resource, application)
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.haSubscription && this.haSubscription.unsubscribe();
    let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    showbody.style.background = "white";
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = null;
    hasColor.style.width = null;
    this._hasSubscription.unsubscribe();
    this.hasSliderSubscription && this.hasSliderSubscription.unsubscribe();
    setTimeout(function () {
      // let hideSidebar: HTMLElement = document.getElementsByClassName("navbar-toggler")[1] as HTMLElement;
      // hideSidebar.click();
      let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
      hasDisplay.style.removeProperty("display");
      let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      hideSidebar.style.removeProperty("display");
    }, 5)

  }


  hasBackgroundcolor() {
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = "0";
    hasColor.style.width = "100%";
  }

  ngAfterViewInit() {
    setTimeout(function () {
      let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      hideSidebar.style.display = "none";
    }, 5)
  }

  calculateStyles(_hasLength: any) {
    return { 'width': (100 / _hasLength) + "%" }
  }

  getRefershTime(id: any, resourceDefination) {
    this.getDoctorList$(id, resourceDefination).subscribe((list: any) => {
      this.myInterval = (list.resource[0].screen_referesh_rate) * 1000
    })
  }
  getPatient(event) {
    this.doctorDetail = event.doctorList[0]
    this.doctorId = this.doctorDetail[0].doctor_id
    if (this.patientList == true) {
      this.patientList = false
    }
    else {
      this.patientList = true
    }
  }

  doctor(wingId: any, resourceDefination: any) {
    this.getDoctorList$(wingId, resourceDefination).subscribe((doctorList) => {
      this.hasDoctor = doctorList.resource;
      this.config = doctorList.resource[0];
      console.log("Doctor List In 1st Index Data", this.config)
      this.hasDoctorLength = this.config.no_of_doctor_in_screen // Display No to doctor with has defefind slot master
      if (window.matchMedia("(max-width: 1336px)").matches) {
        this.hasDoctorLength = this.config.no_of_doctor_in_screen
      }
      if (window.matchMedia("(max-width: 768px)").matches) {
        this.hasDoctorLength = this.hasDoctor.length;
      }
      this.doctorPerScreen = [];
      for (let i = 0; i < Math.ceil(this.hasDoctor.length / this.hasDoctorLength); i++) {
        if (i == 0) {
          this.doctorPerScreen.push(this.hasDoctor.slice(0, this.hasDoctorLength))
        }
        if (i > 0) {
          this.doctorPerScreen.push(this.hasDoctor.slice(i * this.hasDoctorLength, this.hasDoctorLength * (i + 1)))
        }
      }
      if (this.hasDoctor.length <= this.hasDoctorLength) {  // if no to doctor && response data is less than and equal to 
        const source = interval(parseInt(this.config.screen_referesh_rate) * 1000);
        this.hasSliderSubscription = source.subscribe(val => this.onSlideChange(this.activeSlideIndex));
      }
    })
  }

  onSlideChange(event: any) {
    if (this.doctorPerScreen[event].length) {
      for (let i = 0; i < this.doctorPerScreen[event].length; i++) {
        this.doctorPerScreen[event][i]["doctorList"] = this.getlist(this.doctorPerScreen[event][i]['doctor_id'], this.hasDoctor[0]['no_of_patient_in_queue'], this.resourceDef);
      }
    }
  }

  getlist(practitioner_id: any, patient: any, resource) {
    var s = [];
    this.getPatientList$(practitioner_id, patient, resource).subscribe((res) => {
      if (res)
        s.push(res.resource)
    })
    return s;
  }

  getPatientList$(practitioner_id: any, no_of_patent: any, resourceDef: any): Observable<any> {
    var queryId = resourceDef.detail_datasource.query_id;
    var args = "practitioner_id:" + practitioner_id + ",serviceItemCode:opd,slot_date:" + this.moment(this.moment().startOf('day').toString()).valueOf() + ",no_of_patient:" + no_of_patent + ",status:Pending";
    var resource = resourceDef.detail_datasource.resource;
    var application = resourceDef.detail_datasource.application;
    return this.service.get(queryId, args, resource, application);
  }

  checkStage(stage) {
    if (stage == "Started") {
      return true
    } else if (stage == "Prescription Sent") {
      return true
    } else {
      return false
    }
  }

  navbarButtonClick() {  //Menu Bar button click
    if (this.navbarClicked) {
      let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      hideSidebar.click();
      this.navbarClicked = false;
    }
  }


}